import { useContext } from 'react'
import { useQuery, useMutation } from 'react-query'
import { apiGet, apiPatch } from 'api'
import AuthContext from 'context/auth-context'
import UserContext from 'context/user-context'

const getAnalyticConfigs = async (token, municipalityId) => {
  const url = `municipalities/${municipalityId}/analytic_configs`
  const data = await apiGet({ url, token })
  return data
}

export const useAnalyticConfigs = ({ options = {} } = {}) => {
  const token = useContext(AuthContext)
  const { municipality_id } = useContext(UserContext)
  const queryFn = () => getAnalyticConfigs(token, municipality_id)
  const queryKey = ['analytic_configs', municipality_id]

  return useQuery(queryKey, queryFn, {
    ...options
  })
}

const updateAnalyticConfigs = async (token, municipalityId, configs) => {
  const url = `municipalities/${municipalityId}/analytic_configs/batch_update`
  const data = await apiPatch({ url, token, objectName: 'configs', params: configs })
  return data
}

export const useUpdateAnalyticConfigs = ({ options = {} } = {}) => {
  const token = useContext(AuthContext)
  const { municipality_id } = useContext(UserContext)

  return useMutation(
    (configs) => updateAnalyticConfigs(token, municipality_id, configs),
    { ...options }
  )
}

const getAnalyticConfigKeys = async (token, analyticId) => {
  const url = `analytics/${analyticId}/config_keys`
  const data = await apiGet({ url, token })
  return data
}

export const useAnalyticConfigKeys = ({ analyticId, options = {} }) => {
  const token = useContext(AuthContext)
  const queryFn = () => getAnalyticConfigKeys(token, analyticId)
  const queryKey = ['analytic_config_keys', analyticId]

  return useQuery(queryKey, queryFn, {
    enabled: !!analyticId,
    ...options
  })
}
